import 'regenerator-runtime/runtime.js';
import * as THREE from 'three';
import { GUI } from 'dat.gui';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import gsap, { Power2 } from 'gsap';

import stickerTexture from '../../assets/sticker.png';
// import imageTexture from '../../assets/a.png';


// TEXTURE
const image = new Image();
image.src = stickerTexture;

const imageAspect = image.height / image.width;

const size = {
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
  width: 200,
  height: 200,
};

const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(70, window.innerWidth / window.innerHeight, 300, 10000);
camera.position.z = 800;
camera.lookAt(0, 0, 0);

const renderer = new THREE.WebGLRenderer({
  antialias: true,
  alpha: true
});
renderer.setPixelRatio(window.devicePixelRatio);
renderer.setSize(size.windowWidth, size.windowHeight);
renderer.sortObjects = false;
renderer.outputEncoding = THREE.sRGBEncoding;
document.body.appendChild(renderer.domElement);

const controls = new OrbitControls(camera, renderer.domElement);
controls.enableDamping = true;

const geometry = new THREE.PlaneBufferGeometry(1, 1, 80, 80);
const material = new THREE.ShaderMaterial({
  extensions: {
    derivatives: '#extension GL_OES_standard_derivatives : enable'
  },
  side: THREE.DoubleSide,
  transparent: true,
  uniforms: {
    uTexture: {
      value: new THREE.TextureLoader().load(image.src), transparent: true,
    },
    uTime: { 
      value: 0
    },
    uProgress: { 
      value: 1
    },
    uAngle: { 
      value: 0
    },
    uResolution: {
      value: new THREE.Vector4(1, 1, 1, 1)
    },
    uvRate1: {
      value: new THREE.Vector2(1, 1)
    },
  },
  vertexShader: `
		uniform float uAngle;
		uniform float uProgress;
		uniform float uTime;
		uniform vec4 uResolution;

		varying float vFrontShadow;
		varying vec2 vUv;

		mat4 rotationMatrix(vec3 axis, float angle) {
			axis = normalize(axis);
			float s = sin(uAngle);
			float c = cos(uAngle);
			float oc = 1.0 - c;
					
			return mat4(
				oc * axis.x * axis.x + c,
				oc * axis.x * axis.y - axis.z * s,
				oc * axis.z * axis.x + axis.y * s,
				0.0,
				oc * axis.x * axis.y + axis.z * s,
				oc * axis.y * axis.y + c,
				oc * axis.y * axis.z - axis.x * s,
				0.0,
				oc * axis.z * axis.x - axis.y * s,
				oc * axis.y * axis.z + axis.x * s,
				oc * axis.z * axis.z + c,
				0.0,
				0.0,
				0.0,
				0.0,
				1.0
			);
		}

		vec3 rotate(vec3 v, vec3 axis, float angle) {
			mat4 m = rotationMatrix(axis, angle);
			return (m * vec4(v, 1.0)).xyz;
		}

		void main() {
			float pi = 3.1415925;

			float finalAngle = uAngle - 0.*0.3*sin(uProgress*6.);
			
			vec3 newposition = position;

			float rad = 0.05;
  		float rolls = 8.;
			
			newposition = rotate(newposition - vec3(-.5,.5,0.), vec3(0.,0.,1.),-finalAngle) + vec3(-.5,.5,0.);
			
			float offs = (newposition.x + 0.5)/(sin(finalAngle) + cos(finalAngle));
			float tProgress = clamp( (uProgress - offs*0.99)/0.01 , 0.,1.);

			vFrontShadow = clamp((uProgress - offs*0.95)/0.05,0.7,1.);

			newposition.z =  rad + rad*(1. - offs/2.)*sin(-offs*rolls*pi - 0.5*pi);
  		newposition.x =  - 0.5 + rad*(1. - offs/2.)*cos(-offs*rolls*pi + 0.5*pi);
			
			newposition = rotate(newposition - vec3(-.5,.5,0.), vec3(0.,0.,1.),finalAngle) + vec3(-.5,.5,0.);

			newposition = rotate(newposition - vec3(-.5,0.5,rad), vec3(sin(finalAngle),cos(finalAngle),0.), -pi*uProgress*rolls);
  		newposition +=  vec3(
				-.5 + uProgress*cos(finalAngle)*(sin(finalAngle) + cos(finalAngle)),
				0.5 - uProgress*sin(finalAngle)*(sin(finalAngle) + cos(finalAngle)),
    		rad*(1.-uProgress/2.)
  		);

			vec3 finalposition = mix(newposition, position, tProgress);
  		gl_Position = projectionMatrix * modelViewMatrix * vec4(finalposition, 1.0);

			vUv = uv;
		}
	`,
  fragmentShader: `
		uniform sampler2D uTexture;
		uniform vec4 uResolution;
		uniform float uTime;
		uniform float uProgress;

		varying float vFrontShadow;
		varying vec2 vUv;

		void main() {
			vec2 newUV = (vUv - vec2(0.5))*uResolution.zw + vec2(0.5);

			gl_FragColor = texture2D(uTexture,newUV);
    	// gl_FragColor.rgb *=vFrontShadow;
    	// gl_FragColor.a = clamp(uProgress*5.,0.,1.);
		}
	`,
});
const sticker = new THREE.Mesh(geometry, material);

let a1;
let a2;
if (image.height / image.width > imageAspect) {
  a1 = (image.width / image.height) * imageAspect;
  a2 = 1;
} else {
  a1 = 1;
  a2 = image.height / image.width / imageAspect;
}

material.uniforms.uTexture.value.needsUpdate = true;
material.uniforms.uTexture.value.minFilter = THREE.LinearFilter;
material.uniforms.uResolution.value.x = window.innerWidth;
material.uniforms.uResolution.value.y = window.innerHeight;
material.uniforms.uResolution.value.z = a1;
material.uniforms.uResolution.value.w = a2;

sticker.scale.set(image.width, image.height, image.width / 2);

scene.add(sticker);


function rollStickers() {
  gsap.to(material.uniforms.uProgress, {
    duration: 1.7,
    value: 0,
    ease: Power2.out,
    onComplete: () => {
      console.log('finished');
    }
  });
}

function unRollStickers() {
  gsap.to(material.uniforms.uProgress, {
    duration: 1.7,
    value: 1,
    ease: Power2.out,
    onComplete: () => {
      console.log('finished');
    }
  });
}

const btn = {
  enroule: document.querySelector('.btn-enroule'),
  deroule: document.querySelector('.btn-deroule'),
};

btn.enroule.addEventListener('click', rollStickers);
btn.deroule.addEventListener('click', unRollStickers);

function animate() {
  requestAnimationFrame(animate);
  renderer.render(scene, camera);
}
animate();

const gui = new GUI();
gui.add(material.uniforms.uProgress, 'value', 0, 1);
gui.add(camera.position, 'z', 0, 10000);